import { useContext } from 'react';
import GlobalStateContext from '../../context/GlobalStateContext';

function useDemographicCategories() {
  const { demographicCategories } = useContext(GlobalStateContext);

  return { demographicCategories };
}

export default useDemographicCategories;
